import { Block, Container, Image } from '@mote/ui'
import styled, { th } from '@xstyled/styled-components'
import type { HalfSplitLayoutProps } from './halfSplit.layout'
import { HalfSplitLayout } from './halfSplit.layout'
import { Footer, Header } from './shared'

export interface OnboardingLayoutProps extends HalfSplitLayoutProps {
  rightContent: string
}

export const OnboardingLayout = (props: OnboardingLayoutProps): JSX.Element => {
  return (
    <HalfSplitLayout
      rightContent={
        <RightRoot>
          <Image
            maxWidth={500}
            src={props.rightContent}
            alt='Onboarding illustration'
          />
        </RightRoot>
      }
      leftContent={
        <LeftRoot>
          {/* @ts-expect-error */}
          <Header hideNavContent />
          <Container mt={8} centered>
            {props.leftContent}
          </Container>
          {/* @ts-expect-error */}
          <Footer variant='minimal' />
        </LeftRoot>
      }
    />
  )
}

const LeftRoot = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
`

const RightRoot = styled(Block).attrs({
  align: 'center',
  justify: 'center'
})`
  height: 100%;
  width: 100%;
  background: ${th.color('blue.l3')};
  padding: 80px;
  overflow: hidden;
`
